import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProfileAPI from "apiConfig/ProfileAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  userProfilePhoto: null,
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchUserProfilePhoto = createAsyncThunk(
  "profile/userProfilePhoto",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await ProfileAPI.get(`/profiles/${userId}`);
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const UserProfilePhotoSlice = createSlice({
  name: "userProfilePhoto",
  initialState,
  reducers: {
    resetUserProfilePhoto: state => {
      state.userProfilePhoto = null;
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserProfilePhoto.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchUserProfilePhoto.fulfilled, (state, { payload }) => {
        state.userProfilePhoto = payload;
        state.status = Status.LOADED;
      })
      .addCase(fetchUserProfilePhoto.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetUserProfilePhoto } = UserProfilePhotoSlice.actions;
export default UserProfilePhotoSlice.reducer;
